import Ajax from '../common/ajax'
import ApiBase from './api-base'
import Tool from '../common/tool'

export default {
  ...ApiBase,
  model: 'changeAgentLog',
  getPage (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/page`, data)
  },
  getAgentDetail (logId) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/${logId}`)
  },
  auditChangeAgent (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/auditChangeAgent`, data)
  }
}
